import React from 'react'
import Tag from 'components/Tags/Tag'
import { capitalizeStringUtil } from 'packages/src'
import Row from 'components/Row.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'

/**
 * @param props
 * @param props.tags
 * @param props.analyticsEventPrefix
 * @param props.urlPrefix
 * @param props.onClickTag
 * @param props.selectedTag
 * @param props.hasFixedHeight
 * @param props.labelMessageMap
 * @param props.useSlug
 * @returns {Element}
 * @constructor
 */
export default function Tags ({
  labelMessageMap,
  useSlug = true,
  analyticsEventPrefix,
  urlPrefix,
  onClickTag,
  hasFixedHeight,
  selectedTag,
  tags = []
}) {
  const intl = useIntl()

  if (!tags.length) {
    return <></>
  }

  return (
    <Row
      className='tags'
      mt
      wrap
      style={{
        gap: '0.5rem'
      }}
    >
      {
        tags.map(tag => {
          let label
          if (labelMessageMap) {
            label = formatMessageIntlUtil(intl, labelMessageMap[tag.toLowerCase()])
          }
          if (label) {
            label = capitalizeStringUtil(label)
          }

          return (
            <Tag
              key={tag}
              tag={tag}
              label={label}
              analyticsEventPrefix={analyticsEventPrefix}
              urlPrefix={urlPrefix}
              onClick={onClickTag}
              hasFixedHeight={hasFixedHeight}
              isSelected={selectedTag === tag.toLowerCase()}
              useSlug={useSlug}
            />
          )
        })
      }
    </Row>
  )
}
